// extracted by mini-css-extract-plugin
export default {"zoomModal":"T2-z","image":"U2-z","button":"V2-z","isOverlayShown":"W2-z"};